import * as angular from 'angular';
import { MxAttachmentService } from './mx-attachment.service';
import { MxObjectAttachments } from './mx-object-attachments/mx-object-attachments';
import { MxAttachmentsPickerDirective } from './mx-object-attachments/mx-attachments-picker';
import { MxAttachmentProcessService } from './mx-attachment-process.service';

export default angular
	.module('mx.sb.Attachment', [
		/*'mx.shell'*/
	])
	.directive('mxAttachmentsPicker', MxAttachmentsPickerDirective)
	.component('mxObjectAttachments', MxObjectAttachments)
	.service('mx.sb.Attachment.MxAttachmentProcessService', MxAttachmentProcessService)
	.service('mx.sb.Attachment.MxAttachmentService', MxAttachmentService).name;
